import {
    FETCH_COMPLAIN,
    FETCH_COMPLAIN_SUCCESS,
    FETCH_COMPLAIN_FAILED,
    EDIT_COMPLAIN
  } from "../store/types";
  import { firebase } from '../config/configureFirebase';
  import store from '../store/store';
  import { onValue, push, update, query, orderByChild, equalTo } from "firebase/database";

  export const COMPLAIN_STATUSES = ['pending', 'in_progress', 'resolved'];

  /** Las quejas anteriores solo tienen `check` (true = resuelta). */
  export const complainStatusOf = (complain) => {
    if (!complain) return 'pending';
    if (COMPLAIN_STATUSES.includes(complain.status)) return complain.status;
    return complain.check ? 'resolved' : 'pending';
  };

  let complainUnsubscribe = null;

  export const fetchComplain = () => (dispatch) => {
    const {
        auth,
        complainRef
    } = firebase;

    dispatch({
      type: FETCH_COMPLAIN,
      payload: null,
    });

    const uid = auth && auth.currentUser ? auth.currentUser.uid : null;
    const noComplain = () => store.getState().languagedata.defaultLanguage.no_complain;
    if (!uid) {
      dispatch({ type: FETCH_COMPLAIN_FAILED, payload: noComplain() });
      return;
    }
    const profile = store.getState().auth.profile;
    const isAdmin = !!profile && profile.usertype === 'admin';
    const source = isAdmin ? complainRef : query(complainRef, orderByChild('uid'), equalTo(uid));

    if (complainUnsubscribe) complainUnsubscribe();
    complainUnsubscribe = onValue(source, (snapshot) => {
      const data = snapshot.val();
      if (data) {
        const arr = Object.keys(data)
          .map((id) => ({ ...data[id], id }))
          .sort((a, b) => (b.complainDate || 0) - (a.complainDate || 0));
        dispatch({
          type: FETCH_COMPLAIN_SUCCESS,
          payload: arr
        });
      } else {
        dispatch({
          type: FETCH_COMPLAIN_FAILED,
          payload: noComplain(),
        });
      }
    }, (error) => {
      dispatch({
        type: FETCH_COMPLAIN_FAILED,
        payload: (error && error.message) || noComplain(),
      });
    });
  };

  export const editComplain = (reasons, method) => (dispatch) => {

    const {
        auth,
        complainRef,
        editComplainRef
    } = firebase;

    dispatch({
      type: EDIT_COMPLAIN,
      payload: {method, reasons}
    });

    if (method === 'Add') {
      const uid = auth && auth.currentUser ? auth.currentUser.uid : reasons.uid;
      return push(complainRef, { ...reasons, uid, check: false });
    }
    else if(method === 'Update'){
      const status = complainStatusOf(reasons);
      return update(editComplainRef(reasons.id), {
        status,
        check: status === 'resolved',
        processDate: new Date().getTime(),
      });
    }
  }

  /**
   * Cambia el estado de la queja y, si se envía `reply`, deja la respuesta visible para el usuario
   * en la app. La notificación push la envía la función `complainOnUpdated`.
   */
  export const updateComplainStatus = (id, status, reply) => {
    const { auth, editComplainRef } = firebase;
    if (!id || !COMPLAIN_STATUSES.includes(status)) {
      return Promise.reject(new Error('invalid_complain_status'));
    }
    const now = new Date().getTime();
    const current = auth && auth.currentUser;
    const patch = {
      status,
      check: status === 'resolved',
      processDate: now,
      statusUpdatedAt: now,
      attendedBy: current ? current.uid : null,
      attendedByEmail: current && current.email ? current.email : null,
    };
    if (typeof reply === 'string') {
      const text = reply.trim().slice(0, 1000);
      patch.adminReply = text || null;
      patch.repliedAt = text ? now : null;
    }
    return update(editComplainRef(id), patch);
  };
